import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled, { css } from 'styled-components';
import { getPropsBlocker } from '../../utils';
import { fixedCover } from '../../system/mixins';
import { transitionDurationInSec } from '../../constants';
import { getComponentOverride } from '../../system/mixins/getComponentOverride';
var propertyList = {
  disableEffects: true,
  effectToggle: true
};
export var Overlay = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n    z-index: inherit;\n    ", "\n\n    ", ";\n"])), fixedCover, function (_ref) {
  var display = _ref.display,
      effectToggle = _ref.effectToggle,
      disableEffects = _ref.disableEffects;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        opacity: ", ";\n        display: ", ";\n        transition: ", ";\n        background-color: rgba(0, 0, 0, 0.5);\n    "])), effectToggle ? 1 : 0, display ? 'initial' : 'none', disableEffects ? 'none' : "opacity ".concat(transitionDurationInSec, "s ease"));
}, getComponentOverride('Overlay'));